import { HandballIncidentId } from '@collector/sportsapi-client-legacy'

export const HandballManualAddIncidentIds = [
  HandballIncidentId.ThrowSaved,
  HandballIncidentId.MissedThrow,
  HandballIncidentId.ThrowBlocked,
  HandballIncidentId.YellowCard,
  HandballIncidentId.RedCard,
  HandballIncidentId.BlueCard,
  HandballIncidentId.Penalty,
  HandballIncidentId.PenaltySaved,
  HandballIncidentId.MissedPenalty,
  HandballIncidentId.Steal,
  HandballIncidentId.Turnover,
  HandballIncidentId.TwoMinuteSuspension,
]

export const HandballManualAddIncidentSubstitutionIds = []
